"use strict";

require("core-js/modules/es.array.filter");

require("core-js/modules/es.object.get-own-property-descriptor");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = function _default(_ref) {
  var locale = _ref.locale,
      className = _ref.className,
      legals = _ref.legals,
      flow = _ref.flow;
  var filteredLegals = legals.filter(function (obj) {
    return obj.flow === flow;
  });
  var legalsArr = flow ? filteredLegals : legals;

  var arrayToObject = function arrayToObject(array) {
    return array.reduce(function (obj, item) {
      obj[item.language] = item;
      return obj;
    }, {});
  };

  var legalsObject = arrayToObject(legalsArr);

  var _ref2 = legalsObject[locale] || "",
      disclaimer = _ref2.disclaimer;

  return /*#__PURE__*/React.createElement("div", {
    className: className || ""
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: disclaimer
    }
  }));
};

exports.default = _default;